import { createBasicSelector } from "@store/shared/selectors"
import { createSelector } from "reselect"

export const getOrganisations = createBasicSelector((state) => state.organisations.orgs)

export const hasOrganisations = createSelector([getOrganisations], (organisations) => {
	return organisations.length > 0
})
